import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { DownloadSvg } from './Download';

export const DownloadIcon = createIcon('download', DownloadSvg);
/**
 * @deprecated используйте DownloadIcon
 */
export const withDownloadIcon = withIcon('download', DownloadSvg);
